import { Component } from 'react';
import Joi from 'joi-browser';
import { toast } from 'react-toastify';
import './style.scss';

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

class Form extends Component {
  state = {
    name: '',
    phone: '',
    email: '',
    service: '',
    description: '',
    error: {},
    isSubmitting: false,
  };

  componentDidMount() {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action: 'test' }).then((token) => {
          console.log('Test token:', token);
        });
      });
    };
    document.body.appendChild(script);
  }

  schema = {
    email: Joi.string()
      .email({ minDomainAtoms: 2 })
      .required()
      .error((errors) => {
        errors.forEach((err) => (err.message = 'Email must be valid'));
        return errors;
      }),
    phone: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => (err.message = 'Phone number is required'));
        return errors;
      }),
    name: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => (err.message = 'Name is required'));
        return errors;
      }),
    description: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => (err.message = 'Message is required'));
        return errors;
      }),
    service: Joi.string(),
  };

  changeHandler = (event) => {
    const error = { ...this.state.error };
    const errorMessage = this.validationProperty(event);
    if (errorMessage) error[event.target.name] = errorMessage;
    else delete error[event.target.name];

    this.setState({
      [event.target.name]: event.target.value,
      error,
    });
  };

  validationProperty = (event) => {
    const Obj = { [event.target.name]: event.target.value };
    const schema = { [event.target.name]: this.schema[event.target.name] };
    const { error } = Joi.validate(Obj, schema);
    return error ? error.details[0].message : null;
  };

  validate = () => {
    const options = { abortEarly: false };
    const form = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      service: this.state.service,
      description: this.state.description,
    };
    const { error } = Joi.validate(form, this.schema, options);
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  submitHandler = async (event) => {
    event.preventDefault();
    const error = this.validate();
    if (error) {
      this.setState({ error });
      return;
    }

    if (!window.grecaptcha) {
      toast.error('reCAPTCHA failed to load.');
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const token = await window.grecaptcha.execute(siteKey, {
        action: 'submit',
      });

      const formData = new URLSearchParams();
      formData.append('name', this.state.name);
      formData.append('phone', this.state.phone);
      formData.append('email', this.state.email);
      formData.append('service', this.state.service);
      formData.append('message', this.state.description);
      formData.append('recaptchaToken', token);

      const response = await fetch('/scripts/formsubmission.php', {
      //const response = await fetch('/staging/scripts/formsubmission.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const text = await response.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        toast.error('Server returned an unexpected response.');
        console.error('Invalid JSON:', text);
        return;
      }

      if (response.ok && result.success) {
        toast.success(result.success);
        this.setState({
          name: '',
          phone: '',
          email: '',
          service: '',
          description: '',
          error: {},
        });
      } else {
        toast.error(result.error || 'Failed to send message.');
      }
    } catch (err) {
      console.error(err);
      toast.error('Unexpected error occurred.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { name, phone, email, service, description, error } = this.state;

    const options = [
      { level: 'Family Law', value: 'family law' },
      { level: 'Criminal Law', value: 'criminal law' },
      { level: 'Will & Estates', value: 'will and estates' },
      { level: 'Real Estate', value: 'real estate' },
      { level: 'Other', value: 'other' },
    ];

    return (
      <form onSubmit={this.submitHandler} className='contactForm'>
        <div className='row'>
          <div className='col-sm-6 col-12'>
            <div className='formInput'>
              <input
                type='text'
                name='website'
                style={{ display: 'none' }}
                value=''
                readOnly
              />
              <input
                placeholder='Your Name'
                value={name}
                name='name'
                onChange={this.changeHandler}
                className='form-control'
                type='text'
              />
              {error.name && <p>{error.name}</p>}
            </div>
          </div>
          <div className='col-sm-6 col-12'>
            <div className='formInput'>
              <input
                placeholder='Phone'
                value={phone}
                name='phone'
                onChange={this.changeHandler}
                className='form-control'
                type='text'
              />
              {error.phone && <p>{error.phone}</p>}
            </div>
          </div>
          <div className='col-sm-6 col-12'>
            <div className='formInput'>
              <input
                placeholder='Email'
                value={email}
                name='email'
                onChange={this.changeHandler}
                className='form-control'
                type='email'
              />
              {error.email && <p>{error.email}</p>}
            </div>
          </div>
          <div className='col-sm-6 col-12'>
            <div className='formInput'>
              
                <select
                  value={service}
                  className='form-control'
                  onChange={this.changeHandler}
                  name='service'
                >
                  <option value=''>Select Service</option>
                  {options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.level}
                    </option>
                  ))}
                </select>

            </div>
          </div>
          <div className='col-12'>
            <div className='formInput'>
              <textarea
                className='form-control'
                value={description}
                onChange={this.changeHandler}
                placeholder='Your Message'
                name='description'
              />
              {error.description && <p>{error.description}</p>}
            </div>
          </div>
          <div className='col-12'>
            <button type='submit' disabled={this.state.isSubmitting}>
              {this.state.isSubmitting ? 'Sending...' : 'Contact Us'}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default Form;
